import { Enums } from '@bode-canada/core';
import { track } from '@/utils/analytics';
import ModalService from '@/ui-kit/components/modal/ModalService';
import PMBookingCancellationModal from '@/components/features/my-listings/pm-booking-cancellation-modal/PMBookingCancellationModal';
import BaseAction from './base.action';
import { ActionTitle } from '../enums';
import { ButtonFillType } from '@/ui-kit/components/button/enums';
import ProMarketplaceApiService from '@/services/api/serverless/pro-marketplace/ProMarketplaceApiService';

export default class PMBookingCancellationAction extends BaseAction {
  title = ActionTitle.CancelBooking;
  buttonFillType = ButtonFillType.Underlined;
  #analyticEvent = null;

  constructor(config) {
    super(config);
    this.#analyticEvent = config.analyticEvent;
  }

  async execute(listing) {
    const cancellationReason = await PMBookingCancellationAction.#confirmCancellation();
    let isCancelled = false;

    if (cancellationReason) {
      isCancelled = await PMBookingCancellationAction.#cancelPMBooking(listing, cancellationReason);
    }

    this.#trackExecution(listing);
    this.propagateResult(listing, isCancelled);
  }

  static async #cancelPMBooking(listing, cancellationReason) {
    try {
      await ProMarketplaceApiService.updateListingServiceRequestStatus(
        listing.listingId,
        Enums.ServiceRequestStatus.REJECTED,
        cancellationReason,
      );

      return true;
    } catch {
      return false;
    }
  }

  #trackExecution({ listingId }) {
    track(this.#analyticEvent, { listingId });
  }

  static async #confirmCancellation() {
    const cancellationReason = await ModalService.open({
      component: PMBookingCancellationModal,
    });

    return cancellationReason || false;
  }
}
